<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-03-21 17:36:44
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-04-13 15:30:44
 * @FilePath: \ioc_base\src\modules\fire\components\fireMonitorDevice.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="fireDevice">
    <el-scrollbar style="height: 100%">
      <div
        v-for="(item, key, index) in deviceInfo"
        :key="index"
        class="fireDevice-list"
      >
        <div class="list-title">
          {{ deviceTypeInfo[key] }}
        </div>
        <div>
          <component
            :is="filterName(key)"
            :class="'list-content_' + key"
            :className="'list-content_' + key"
            :deviceInfo="item"
          ></component>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import highWater from "./highWater";
import listImg from "./list-img";
import firePower from "./firePower";
export default {
  props: {
    deviceInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    highWater,
    listImg,
    firePower
  },
  data() {
    return {
      deviceTypeInfo: {
        27: "消防主机控制器",
        28: "自动喷淋和消防栓灭火系统",
        29: "防烟排烟系统",
        32: "电气火灾",
        33: "可燃气体控制器",
        34: "可燃气体探测点",
        35: "消防电源",
        36: "消防水池",
        37: "高位水箱",
      },
      deviceTypeName: {
        28: "listImg",
        29: "listImg",
        32: "firePower",
        33: "highWater",
        34: "highWater",
        35: "firePower",
        36: "highWater",
        37: "highWater",
      },
    };
  },
  mounted() {},
  methods: {
    filterName(val) {
      return this.deviceTypeName[val];
    },
  },
};
</script>

<style lang="scss" scoped>
.fireDevice {
  height: 100%;
  // background: #181f2e;
  background: #fff;

  &-list {
    padding: 16px;
    margin-bottom: 12px;
  }
  .list {
    &-title {
      line-height: 18px;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      // color: #c7c9ce;
      margin-bottom: 12px;
    }
    &-content {
      // padding:12px 12px 0;
    }
  }
}
</style>